import React, { useState, useRef } from "react";
import { IconButton, Tooltip, Popper, Paper, List, ListItem, ListItemText, ClickAwayListener, Divider, Typography } from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmarks";
import { useNavigate } from "react-router-dom";
import { getBasePathBasedOnChartType } from "../../common/utility/helperFunc";
import { captureChartInteraction } from "../../analytics/chartsTool";
import EditIcon from '@mui/icons-material/EditNote';

const BookmarkComponent = ({ bookmarks, onBookmarkClick }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null); // Reference to IconButton

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleManageClick = () => {
        navigate("/global-bookmarks"); // Navigate to global bookmarks page
        setOpen(false);
    };

    const openBookmark = (event, item) => {
        setOpen(false);
        const basePath = getBasePathBasedOnChartType(item.chartType)
        console.log("GlobalBK openBookmark item=", item, item.chartType, item.id, basePath)
        captureChartInteraction('charts_bookmark_opened', { bookmark_type: 'global' });

        const url = `${process.env.REACT_APP_URL}${basePath}?globalBookmarkID=${item.id}`

        if (event.ctrlKey || event.metaKey) {
            window.open(`${url}`, '_blank', 'noreferrer');
        } else {
            window.location.href = url;
        }

    }
    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                sx={{ 
                    mr: { xs: 0.5, sm: 1 }, // Smaller margin on mobile
                    p: { xs: 0.5, sm: 1 }    // Smaller padding on mobile
                }}
                size="small"
                edge="start"
                aria-label="bookmark"
            >
                <Tooltip title="Global Bookmarks">
                    <BookmarkIcon sx={{ 
                        color: "primaryTheme.shade01", 
                        width: { xs: "20px", sm: "24px" }, 
                        height: { xs: "20px", sm: "24px" } 
                    }} />
                </Tooltip>
            </IconButton>

            {/* Popper for showing the list below the button */}
            {/* <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" style={{ zIndex: 1300,mr:-8 }}> */}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-end"
                style={{ 
                    zIndex: 1300, 
                    transform: "translateX(-20px)" // Moves it 20px left
                }}
                modifiers={[
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            padding: 8
                        }
                    }
                ]}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                        elevation={3}
                        sx={{
                            pl: { xs: 0.5, sm: 1 },
                            pr: { xs: 0.5, sm: 1 },
                            pb: { xs: 0.5, sm: 1 },
                            minWidth: { xs: 180, sm: 200 },
                            maxHeight: { xs: 300, sm: 340 },  // Slightly smaller on mobile
                            overflowY: "auto" // Enable scrolling when content overflows
                        }}
                    >
                        <List>
                            {/* Manage Bookmark Button */}
                            <ListItem
                                button
                                onClick={handleManageClick}
                                sx={{
                                    fontWeight: "bold",
                                    color: "primary.main",
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#0d203f",
                                    zIndex: 1
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Typography variant="body1" sx={{ 
                                            fontSize: { xs: "14px", sm: "16px" }, 
                                            fontWeight: "bold" 
                                        }}>
                                            Global Bookmarks <EditIcon sx={{
                                                color: "#ffffff",
                                                ml: { xs: 0.2, sm: 0.4 },
                                                mt: 0,
                                                mb: -0.3,
                                                width: { xs: 16, sm: 18 },
                                                height: { xs: 16, sm: 18 }
                                            }}></EditIcon>
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <Divider /> {/* Adds a separator */}
                            {bookmarks.length > 0 ? (
                                bookmarks.map((bookmark) => (
                                    <ListItem button key={bookmark.id} onClick={(event) => openBookmark(event, bookmark)}>
                                        <ListItemText primary={
                                            <Typography variant="body2" sx={{ 
                                                fontSize: { xs: "11px", sm: "12px" }
                                            }}>
                                                {bookmark.name}
                                            </Typography>
                                        } />
                                    </ListItem>
                                ))
                            ) 
                            : (
                                <></>
                                // <ListItem>
                                //     {/* <ListItemText primary="No bookmarks available" /> */}
                                // </ListItem>
                            )
                            }
                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default BookmarkComponent;
